/*eslint-disable*/
import { HamburgerIcon } from "@chakra-ui/icons";
import { toastError, toastWarning, presentMutationError } from "../../utils/showApiErrorToast";
// chakra imports
import {
    Box,
    Button,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerOverlay,
    Flex,
    Image,
    Link,
    Stack,
    VStack,
    Text,
    useColorModeValue,
    useDisclosure,
    useBreakpointValue,
    useMediaQuery,
    Icon,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Portal,
    Avatar,
    Switch,
    Spinner,
} from "@chakra-ui/react";
import { useTheme } from "next-themes";
import { SidebarNavRouteRow } from "./SidebarNavRouteRow";
import { Separator } from "../Separator/Separator";
import React, { useState, useRef, useEffect, useCallback } from "react";
import { NavLink, useLocation, useHistory } from "react-router-dom";
import { RouteConfigArray } from "../../types/routes";
import { useClerkAuth } from "../../hooks/useClerkAuth";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { useResyncTrades } from "../../hooks/useResyncTrades";
import { useActiveBrokerAccount } from "../../hooks/useActiveBrokerAccount";
import { useRunInstrumentSetupAfterSync } from "../../hooks/useRunInstrumentSetupAfterSync";
import { useActiveBrokerCapabilities } from "../../hooks/useActiveBrokerCapabilities";
import { invalidateTradeDataCaches } from "../../hooks/useTradeStatistics";
import avatar1 from "../../assets/img/avatars/avatar1.png";
import avatar2 from "../../assets/img/avatars/avatar2.png";
import avatar3 from "../../assets/img/avatars/avatar3.png";
import avatar4 from "../../assets/img/avatars/avatar4.png";
import {
  SIDEBAR_BRAND_LOGO_COLLAPSED_SIZE,
  SIDEBAR_BRAND_LOGO_COLLAPSED_SRC,
  SIDEBAR_BRAND_LOGO_EXPANDED_MAX_HEIGHT,
  SIDEBAR_BRAND_LOGO_EXPANDED_MAX_WIDTH,
  SIDEBAR_BRAND_LOGO_EXPANDED_SRC,
} from "../../constants/sidebarBrandLogo";
import { ItemContent } from "../Menu/ItemContent";
import { MdSync, MdAccountBalance } from "react-icons/md";
import { AiOutlineBell, AiOutlineMore, AiOutlineUser, AiOutlineLogout } from "react-icons/ai";
import { syncTradesFromBroker } from "../../services/tradeApi";
import { afterBrokerResyncWaitForAnalytics } from "../../utils/brokerSyncStatusPoll";
import GradientButton from "../../views/Dashboard/Profile/components/GradientButton";
import { AccountSelectorModal } from "./AccountSelectorModal";
import { formatAccountDisplayLabelShort, formatAccountDisplayLabel } from "../../services/liquidBrokersApi";
import NotificationModal from "../Notifications/NotificationModal";
import { fetchNotifications } from "../../services/notificationsApi";
import { getPerformanceSummaryPreviewText, isPerformanceSummaryEventKey, resolveNotificationDisplayTitle } from "../../utils/notificationDisplay";
import { toast } from "sonner";
import { findTradeAccount } from "../../utils/tradeAccountAnalytics";
import { shouldShowSidebarResyncTrades } from "../../utils/tradeAccountSource";


interface SidebarResponsiveProps {
  logoText?: string;
  routes: RouteConfigArray;
  secondary?: boolean;
  onOpen?: () => void;
  [key: string]: any;
}

function SidebarResponsive(props: SidebarResponsiveProps) {
    // to check for active links and opened collapses
    let location = useLocation();
    const history = useHistory();
    const [isMobile] = useMediaQuery("(max-width: 1023px)");
    const { hasTradarAccess, isAdmin } = useFeatureFlags();
    const { signOut, isLoaded, user } = useClerkAuth();
    const [isSigningOut, setIsSigningOut] = useState(false);
    const { isResyncing, setResyncing } = useResyncTrades();
    const {
      activeAccountCode,
      activeBrokerName,
      accounts: brokerAccounts,
      loading: accountsLoading,
      isConnected: brokerConnected,
      setActiveTradeAccount,
      refetch: refetchBrokerAccounts,
      removeTradeAccount,
    } = useActiveBrokerAccount();
    const runInstrumentSetupAfterSync = useRunInstrumentSetupAfterSync();
    const { capabilities, loading: brokerCapabilitiesLoading } = useActiveBrokerCapabilities(
      activeAccountCode,
      activeBrokerName
    );
    const activeTradeAccount = React.useMemo(
      () => findTradeAccount(brokerAccounts, activeAccountCode, activeBrokerName),
      [brokerAccounts, activeAccountCode, activeBrokerName]
    );
    const showSidebarResyncTrades = React.useMemo(
      () =>
        shouldShowSidebarResyncTrades({
          activeAccountCode,
          activeBrokerName,
          activeAccount: activeTradeAccount,
          brokerSupportsAutoSync: capabilities?.auth?.supports_auto_sync,
          capabilitiesResolved: !brokerCapabilitiesLoading,
        }),
      [
        activeAccountCode,
        activeTradeAccount,
        capabilities?.auth?.supports_auto_sync,
        brokerCapabilitiesLoading,
      ]
    );
    const [isSwitchingAccount, setIsSwitchingAccount] = useState(false); 
    const profileCardRef = useRef<HTMLDivElement>(null);
    const notificationsButtonRef = useRef<HTMLButtonElement>(null);
    const [cardWidth, setCardWidth] = useState<number | undefined>(undefined);
    const bottomSectionRef = useRef<HTMLDivElement>(null);
    const [bottomSectionHeight, setBottomSectionHeight] = useState<number>(0);
    const brandSectionRef = useRef<HTMLDivElement>(null);
    const [brandSectionHeight, setBrandSectionHeight] = useState<number>(0);
    const menuListRef = useRef<HTMLDivElement>(null);
    const notificationsMenuListRef = useRef<HTMLDivElement>(null);
    const { isOpen: isProfileMenuOpen, onOpen: onProfileMenuOpen, onClose: onProfileMenuClose } = useDisclosure();
    const { isOpen: isNotificationsMenuOpen, onOpen: onNotificationsMenuOpen, onClose: onNotificationsMenuClose } = useDisclosure();
    const { isOpen: isNotificationsModalOpen, onOpen: onNotificationsModalOpen, onClose: onNotificationsModalClose } = useDisclosure();
    const { isOpen: isAccountModalOpen, onOpen: onAccountModalOpen, onClose: onAccountModalClose } = useDisclosure();
    const { resolvedTheme, setTheme } = useTheme();
    const isDark = resolvedTheme === "dark";
    const notificationRowHoverBg = useColorModeValue("gray.50", "whiteAlpha.50");

    // Drawer state (mobile sidebar)
    const { isOpen, onOpen, onClose } = useDisclosure();

    type SidebarNotificationPreview = {
      id: string;
      title: string;
      message: string;
      time: string;
      isRead: boolean;
      messageIsPlainText?: boolean;
    };
    const [notificationsPreview, setNotificationsPreview] = useState<SidebarNotificationPreview[]>([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [notificationModalFocusId, setNotificationModalFocusId] = useState<string | null>(null);

    const loadNotificationsPreview = useCallback(async () => {
      try {
        const { notifications, unreadCount } = await fetchNotifications({ limit: 5 });
        const previews: SidebarNotificationPreview[] = notifications.map((n) => {
          const isPerf = isPerformanceSummaryEventKey(n.eventKey);
          return {
            id: n.id,
            title: resolveNotificationDisplayTitle(n.title, n.eventKey ?? null, n.data),
            message: isPerf ? getPerformanceSummaryPreviewText(n.data) : n.bodyMarkdown,
            time: new Date(n.createdAt).toLocaleString("en-US", {
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            }),
            isRead: n.statusInApp === "read",
            messageIsPlainText: isPerf,
          };
        });
        setNotificationsPreview(previews);
        if (typeof unreadCount === "number") setUnreadCount(unreadCount);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Failed to load mobile notifications preview:", e);
      }
    }, []);

    useEffect(() => {
      if (!isOpen) return;
      void loadNotificationsPreview();
    }, [isOpen, loadNotificationsPreview]);

    useEffect(() => {
      if (!isOpen || !isNotificationsMenuOpen) return;
      void loadNotificationsPreview();
    }, [isNotificationsMenuOpen, isOpen, loadNotificationsPreview]);

    // Get user's avatar image with fallback
    const avatarImage = user?.imageUrl || avatar4;
    
    // Get user's full name and email
    const fullName = user
      ? `${user.firstName || ""} ${user.lastName || ""}`.trim() || "User"
      : "User";
    const email = user?.primaryEmailAddress || user?.emailAddresses?.[0]?.emailAddress || "No email";
    
    // Close profile menu when notifications menu opens and vice versa
    useEffect(() => {
      if (isNotificationsMenuOpen && isProfileMenuOpen) {
        onProfileMenuClose();
      }
    }, [isNotificationsMenuOpen, isProfileMenuOpen, onProfileMenuClose]);

    useEffect(() => {
      if (isProfileMenuOpen && isNotificationsMenuOpen) {
        onNotificationsMenuClose();
      }
    }, [isProfileMenuOpen, isNotificationsMenuOpen, onNotificationsMenuClose]);

    const lastCardWidthRef = useRef<number | undefined>(undefined);
    const lastBottomSectionHeightRef = useRef<number>(0);
    const lastBrandSectionHeightRef = useRef<number>(0);
    const bottomHeightRafRef = useRef<number | null>(null);
    const brandHeightRafRef = useRef<number | null>(null);

    // Measure card width after render (for dropdown menu width)
    useEffect(() => {
      const measureWidth = () => {
        if (profileCardRef.current) {
          const width = profileCardRef.current.offsetWidth;
          if (lastCardWidthRef.current !== width) {
            lastCardWidthRef.current = width;
            setCardWidth(width);
          }
        }
      };
      
      // Measure after drawer opens
      if (isOpen) {
        const id = window.setTimeout(measureWidth, 100);
        return () => clearTimeout(id);
      }
    }, [isOpen, fullName, email]);

    // Measure bottom section height for scroll padding
    useEffect(() => {
      const measureHeight = () => {
        if (bottomSectionRef.current) {
          const height = bottomSectionRef.current.offsetHeight;
          if (lastBottomSectionHeightRef.current !== height) {
            lastBottomSectionHeightRef.current = height;
            setBottomSectionHeight(height);
          }
        }
      };
      
      if (isOpen) {
        measureHeight();
        const timeoutId = setTimeout(measureHeight, 100);
        
        let resizeObserver: ResizeObserver | null = null;
        if (bottomSectionRef.current && typeof ResizeObserver !== 'undefined') {
          resizeObserver = new ResizeObserver(() => {
            if (bottomHeightRafRef.current != null) cancelAnimationFrame(bottomHeightRafRef.current);
            bottomHeightRafRef.current = requestAnimationFrame(() => {
              bottomHeightRafRef.current = null;
              measureHeight();
            });
          });
          resizeObserver.observe(bottomSectionRef.current);
        }
        
        return () => {
          clearTimeout(timeoutId);
          if (bottomHeightRafRef.current != null) {
            cancelAnimationFrame(bottomHeightRafRef.current);
            bottomHeightRafRef.current = null;
          }
          if (resizeObserver && bottomSectionRef.current) {
            resizeObserver.disconnect();
          }
        };
      }
    }, [isResyncing, isProfileMenuOpen, isNotificationsMenuOpen, isOpen]);

    // Measure brand section height
    useEffect(() => {
      const measureBrandHeight = () => {
        if (brandSectionRef.current) {
          const height = brandSectionRef.current.offsetHeight;
          if (lastBrandSectionHeightRef.current !== height) {
            lastBrandSectionHeightRef.current = height;
            setBrandSectionHeight(height);
          }
        }
      };
      
      if (isOpen) {
        measureBrandHeight();
        const timeoutId = setTimeout(measureBrandHeight, 100);
        
        let resizeObserver: ResizeObserver | null = null;
        if (brandSectionRef.current && typeof ResizeObserver !== 'undefined') {
          resizeObserver = new ResizeObserver(() => {
            if (brandHeightRafRef.current != null) cancelAnimationFrame(brandHeightRafRef.current);
            brandHeightRafRef.current = requestAnimationFrame(() => {
              brandHeightRafRef.current = null;
              measureBrandHeight();
            });
          });
          resizeObserver.observe(brandSectionRef.current);
        }
        
        return () => {
          clearTimeout(timeoutId);
          if (brandHeightRafRef.current != null) {
            cancelAnimationFrame(brandHeightRafRef.current);
            brandHeightRafRef.current = null;
          }
          if (resizeObserver && brandSectionRef.current) {
            resizeObserver.disconnect();
          }
        };
      }
    }, [isOpen]);

    // Calculate and position profile dropdown to align bottom edges
    useEffect(() => {
      if (!isProfileMenuOpen || !isOpen) {
        if (menuListRef.current) {
          menuListRef.current.removeAttribute('data-positioned');
        }
        return;
      }
      
      if (!profileCardRef.current) return;

      const calculatePosition = () => {
        if (!profileCardRef.current || !menuListRef.current) {
          setTimeout(calculatePosition, 10);
          return;
        }

        const profileCardRect = profileCardRef.current.getBoundingClientRect();
        const menuListRect = menuListRef.current.getBoundingClientRect();
        
        if (menuListRect.width === 0 || menuListRect.height === 0) {
          setTimeout(calculatePosition, 10);
          return;
        }
        
        // For mobile drawer, position menu above the card, aligned to left
        // Ensure menu stays within viewport
        const left = Math.max(16, profileCardRect.left); // At least 16px from left edge
        const top = profileCardRect.top - menuListRect.height - 8; // 8px gap above
        
        // Ensure menu doesn't go off-screen to the right
        const maxLeft = window.innerWidth - menuListRect.width - 16;
        const finalLeft = Math.min(left, maxLeft);
        
        // Ensure menu doesn't go off-screen at the top
        const finalTop = Math.max(16, top);
        
        menuListRef.current.style.position = 'fixed';
        menuListRef.current.style.left = `${finalLeft}px`;
        menuListRef.current.style.top = `${finalTop}px`;
        menuListRef.current.style.right = 'auto';
        menuListRef.current.style.bottom = 'auto';
        menuListRef.current.style.visibility = 'visible';
        menuListRef.current.style.opacity = '1';
        menuListRef.current.setAttribute('data-positioned', 'true');
      };

      const timeoutId = setTimeout(calculatePosition, 0);
      const rafId = requestAnimationFrame(() => {
        calculatePosition();
      });
      
      window.addEventListener('resize', calculatePosition);
      window.addEventListener('scroll', calculatePosition, true);
      
      const handleClickOutside = (event: MouseEvent) => {
        if (
          menuListRef.current &&
          !menuListRef.current.contains(event.target as Node) &&
          profileCardRef.current &&
          !profileCardRef.current.contains(event.target as Node)
        ) {
          onProfileMenuClose();
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      
      return () => {
        clearTimeout(timeoutId);
        cancelAnimationFrame(rafId);
        window.removeEventListener('resize', calculatePosition);
        window.removeEventListener('scroll', calculatePosition, true);
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [isProfileMenuOpen, isOpen, fullName, email, cardWidth, onProfileMenuClose]);

    // Calculate and position notifications dropdown
    useEffect(() => {
      if (!isNotificationsMenuOpen || !isOpen) {
        if (notificationsMenuListRef.current) {
          notificationsMenuListRef.current.removeAttribute('data-positioned');
        }
        return;
      }
      
      if (!notificationsButtonRef.current) return;

      const calculatePosition = () => {
        if (!notificationsButtonRef.current || !notificationsMenuListRef.current) {
          setTimeout(calculatePosition, 10);
          return;
        }

        const buttonRect = notificationsButtonRef.current.getBoundingClientRect();
        const menuListRect = notificationsMenuListRef.current.getBoundingClientRect();
        
        if (menuListRect.width === 0 || menuListRect.height === 0) {
          setTimeout(calculatePosition, 10);
          return;
        }
        
        // For mobile drawer, position menu above the button, aligned to left
        // Ensure menu stays within viewport
        const left = Math.max(16, buttonRect.left); // At least 16px from left edge
        const top = buttonRect.top - menuListRect.height - 8; // 8px gap above
        
        // Ensure menu doesn't go off-screen to the right
        const maxLeft = window.innerWidth - menuListRect.width - 16;
        const finalLeft = Math.min(left, maxLeft);
        
        // Ensure menu doesn't go off-screen at the top
        const finalTop = Math.max(16, top);
        
        notificationsMenuListRef.current.style.position = 'fixed';
        notificationsMenuListRef.current.style.left = `${finalLeft}px`;
        notificationsMenuListRef.current.style.top = `${finalTop}px`;
        notificationsMenuListRef.current.style.right = 'auto';
        notificationsMenuListRef.current.style.bottom = 'auto';
        notificationsMenuListRef.current.style.visibility = 'visible';
        notificationsMenuListRef.current.style.opacity = '1';
        notificationsMenuListRef.current.setAttribute('data-positioned', 'true');
      };

      const timeoutId = setTimeout(calculatePosition, 0);
      const rafId = requestAnimationFrame(() => {
        calculatePosition();
      });
      
      window.addEventListener('resize', calculatePosition);
      window.addEventListener('scroll', calculatePosition, true);
      
      const handleClickOutside = (event: MouseEvent) => {
        if (
          notificationsMenuListRef.current &&
          !notificationsMenuListRef.current.contains(event.target as Node) &&
          notificationsButtonRef.current &&
          !notificationsButtonRef.current.contains(event.target as Node)
        ) {
          onNotificationsMenuClose();
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      
      return () => {
        clearTimeout(timeoutId);
        cancelAnimationFrame(rafId);
        window.removeEventListener('resize', calculatePosition);
        window.removeEventListener('scroll', calculatePosition, true);
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [isNotificationsMenuOpen, isOpen, onNotificationsMenuClose]);
    
    // Handle profile navigation
    const handleProfileClick = () => {
      history.push("/profile");
      onClose();
    };
    
    // Handle sign out
    const handleSignOut = async () => {
      setIsSigningOut(true);
      try {
        await signOut();
        window.location.assign("/auth/signin");
      } catch (error) {
        console.error("Sign out error:", error);
        setIsSigningOut(false);
      }
    };

    const handleSwitchAccount = async (brokerName: string, accountCode: string) => {
      if (brokerName === activeBrokerName && accountCode === activeAccountCode) return;
      setIsSwitchingAccount(true);
      try {
        await setActiveTradeAccount(brokerName, accountCode);
        const label = brokerAccounts.find(
          (a: { accountCode: string; brokerName: string }) =>
            a.accountCode === accountCode && a.brokerName === brokerName
        );
        const displayName = label ? formatAccountDisplayLabel(label) : accountCode;
        toast.success("Switched account", {
          description: `Now viewing ${displayName}`,
        });
      } catch (e) {
        presentMutationError(e, "Failed to switch account");
      } finally {
        setIsSwitchingAccount(false);
      }
    };

    const handleSidebarResyncTrades = async () => {
      if (!isLoaded || !user?.id) {
        toastError("Authentication required", {
          description: "Please log in to sync trades.",
        });
        return;
      }

      const accountCode = activeAccountCode;

      if (!accountCode || !activeBrokerName) {
        toastWarning("No synced trade account found", {
          description: "Please connect and sync a trade account from the Broker Management page first.",
        });
        history.push("/profile");
        onClose();
        return;
      }

      setResyncing(true);
      try {
        const result = await syncTradesFromBroker(accountCode, undefined, undefined, activeBrokerName);
        const stats = result?.sync_stats ?? { created: 0, updated: 0, skipped: 0, total: 0 };

        const syncStatus = await afterBrokerResyncWaitForAnalytics({
          accountCode,
          brokerName: activeBrokerName,
          userId: user.id,
          action: "sync",
          refetchBrokerAccounts,
        });

        if (syncStatus.phase === "needs_instrument_setup") {
          toast.info("Instrument setup required", {
            description: "Sync completed. Resolve pending symbols before dashboard analytics can load.",
          });
          await runInstrumentSetupAfterSync(syncStatus, syncStatus.account_code || accountCode, {
            skipTradeAccountsRefetch: true,
          });
          return;
        }

        const message =
          result?.sync_stats == null
            ? "Trades synced successfully."
            : stats.created > 0 || stats.updated > 0
              ? `Synced ${stats.total} order(s): ${stats.created} trades created, ${stats.updated} trades updated, ${stats.skipped} skipped`
              : `All ${stats.total} order(s) are already up to date`;

        toast.success("Re-sync successful", {
          description: `${message} (${syncStatus.closed_trades} closed, ${syncStatus.open_trades} open).`,
        });
        await runInstrumentSetupAfterSync(result, accountCode, {
          skipTradeAccountsRefetch: true,
        });
      } catch (error: unknown) {
        presentMutationError(error, "Re-sync failed");
      } finally {
        setResyncing(false);
      }
    };

    // this is for the rest of the collapses
    const [state, setState] = useState<{ [key: string]: boolean }>({});
    const mainPanel = useRef<HTMLDivElement>(null);
    // verifies if routeName is the one active (in browser input)
    const activeRoute = (routeName: string): string => {
      return location.pathname === routeName ? "active" : "";
    };
  
    // Color mode values
    const navbarIcon = useColorModeValue("gray.500", "gray.200");
    const cardBg = useColorModeValue("white", "#151517");
    const cardBorder = useColorModeValue("gray.200", "gray.600");
    const cardText = useColorModeValue("gray.700", "gray.200");
    const cardTextSecondary = useColorModeValue("gray.500", "gray.400");
    const cardHoverBg = useColorModeValue("gray.50", "gray.700");
    const cardHoverBorder = useColorModeValue("gray.300", "gray.500");
    const cardActiveBg = useColorModeValue("gray.100", "gray.600");
  
    const createLinks = (routes: RouteConfigArray): (JSX.Element | null)[] => {
      if (!routes || !Array.isArray(routes) || routes.length === 0) {
        return [];
      }
      const inactiveColor = useColorModeValue("gray.400", "white");

      return routes.map((prop, key) => {
        if (prop.redirect) {
          return null;
        }
        if (prop.hideFromSidebar) {
          return null;
        }
        // Skip account category (ACCOUNT PAGES)
        if (prop.category === "account") {
          return null;
        }
        // Skip RTL route
        if (prop.layout === "/rtl") {
          return null;
        }
        // Skip course overview route (it's accessed via university page, not directly)
        if (prop.path && prop.path.startsWith("/university/course")) {
          return null;
        }
        // Hide Tradar route if user doesn't have access
        if (prop.path === "/tradar" && !hasTradarAccess) {
          return null;
        }
        // Hide Admin route if user is not an admin
        if (prop.path === "/system" && !isAdmin) {
          return null;
        }
        if (prop.path === "/strategy-rd" && !isAdmin) {
          return null;
        }
        // Skip journal route
        if (prop.path === "/journal") {
          return null;
        }
        if (prop.category && prop.views) {
          const st: { [key: string]: boolean } = {};
          if (prop.state) {
            st[prop.state] = !state[prop.state];
          }
          return (
            <div key={prop.name || key}>
              <Text
                color={useColorModeValue("#D3D3D3", "white")}
                fontWeight="bold"
                mb={{
                  xl: "12px",
                }}
                mx="auto"
                ps="16px"
                py="12px"
              >
                {document.documentElement.dir === "rtl"
                  ? prop.rtlName
                  : prop.name}
              </Text>
              {createLinks(prop.views)}
            </div>
          );
        }
        if (!prop.path || prop.layout == null) {
          return null;
        }
        // Skip auth routes (sign in/sign up) - they shouldn't appear in the sidebar
        if (prop.layout === "/auth") {
          return null;
        }
        // Skip detail/parameterized routes in sidebar nav.
        if (prop.path.includes(":")) {
          return null;
        }
        const routePath = `${prop.layout || ""}${prop.path}`;
        return (
          <SidebarNavRouteRow
            key={prop.name || key}
            routePath={routePath}
            prop={prop}
            variant="drawer"
            isCollapsed={false}
            inactiveColor={inactiveColor}
            activeRoute={activeRoute}
            onAfterNavigate={onClose}
          />
        );
      });
    };
    
    const { logoText, routes, onOpen: onOpenConfigurator, ...rest } = props;
  
    const links = <>{createLinks(routes)}</>;
    //  BRAND
    //  Chakra Color Mode
    // Burger menu should always be tropical surf color (#38BBD1)
    let hamburgerColor = "#38BBD1";
    const brand = (
      <Box pt={"25px"} mb="12px">
        <Link
          href={`${process.env.PUBLIC_URL}/#/`}
          target="_blank"
          display="flex"
          lineHeight="100%"
          mb="30px"
          fontWeight="bold"
          justifyContent="flex-start"
          alignItems="center"
          fontSize="11px"
          pl="0"
          ml="8px"
        >
          <Image
            src={SIDEBAR_BRAND_LOGO_EXPANDED_SRC}
            alt="Tessera"
            maxW={SIDEBAR_BRAND_LOGO_EXPANDED_MAX_WIDTH}
            w="auto"
            maxH={SIDEBAR_BRAND_LOGO_EXPANDED_MAX_HEIGHT}
            h="auto"
            objectFit="contain"
          />
        </Link>
        <Box
          borderBottom="1px solid"
          borderColor={useColorModeValue("gray.200", "gray.700")}
          mb="12px"
        />
      </Box>
    );
  
    // SIDEBAR
    const btnRef = useRef<HTMLButtonElement>(null);
    // Color variables
    return (
      <Flex
        display={{ sm: "flex", xl: "none" }}
        ref={mainPanel}
        alignItems="center"
        justifyContent="space-between"
        w="100%"
        minW="100%"
        flex="1"
        px={0}
      >
        {/* Logo on the left */}
        <Box flexShrink={0}>
          <Image
            src={SIDEBAR_BRAND_LOGO_COLLAPSED_SRC}
            alt="Tessera"
            maxW={SIDEBAR_BRAND_LOGO_COLLAPSED_SIZE}
            w={SIDEBAR_BRAND_LOGO_COLLAPSED_SIZE}
            h="auto"
            objectFit="contain"
          />
        </Box>
        
        {/* Burger menu on the right */}
        <Box
          as="button"
          onClick={onOpen}
          cursor="pointer"
          flexShrink={0}
        >
          <HamburgerIcon
            color={hamburgerColor}
            w={{ sm: "28px", xl: "18px" }}
            h={{ sm: "28px", xl: "18px" }}
          />
        </Box>
        <Drawer
          isOpen={isOpen}
          onClose={onClose}
          placement={document.documentElement.dir === "rtl" ? "right" : "left"}
          blockScrollOnMount={false}
          closeOnOverlayClick={true}
          trapFocus={true}
          size="sm"
        >
          <DrawerOverlay 
            bg="blackAlpha.600"
            style={{ zIndex: 1400 }}
          />
          <DrawerContent
            w="260px"
            maxW="260px"
            borderRadius="0"
            p={0}
            m={0}
            h="100vh"
            bg={useColorModeValue("white", "#151517")}
            style={{ 
              zIndex: 1401,
              transition: "transform 0.25s ease-linear 0.05s, opacity 0.25s ease-linear 0.05s",
            }}
            sx={{
              padding: "0 !important",
              margin: "0 !important",
              top: "0 !important",
              bottom: "0 !important",
              left: document.documentElement.dir === "rtl" ? "auto !important" : "0 !important",
              right: document.documentElement.dir === "rtl" ? "0 !important" : "auto !important",
              '&[data-state="open"]': {
                transform: "translateX(0)",
                opacity: 1,
              },
              '&[data-state="closed"]': {
                transform: `translateX(${document.documentElement.dir === "rtl" ? "320px" : "-320px"})`,
                opacity: 0,
              },
            }}
          >
            <DrawerCloseButton
              _focus={{ boxShadow: "none" }}
              _hover={{ boxShadow: "none" }}
            />
            <DrawerBody maxW="260px" px="16px" pb="0" position="relative" display="flex" flexDirection="column" h="100%">
              <Box ref={brandSectionRef} flexShrink={0}>{brand}</Box>
              <Box
                flex="1"
                minH="0"
                maxH={brandSectionHeight > 0 && bottomSectionHeight > 0 
                  ? `calc(100vh - ${brandSectionHeight}px - ${bottomSectionHeight}px - 16px)` 
                  : brandSectionHeight > 0 
                  ? `calc(100vh - ${brandSectionHeight}px - 266px)` 
                  : bottomSectionHeight > 0 
                  ? `calc(100vh - 100px - ${bottomSectionHeight}px - 16px)` 
                  : "calc(100vh - 366px)"}
                overflowY="auto"
                overflowX="hidden"
                pr="4px"
                sx={{
                  '&::-webkit-scrollbar': {
                    width: '6px',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)',
                    borderRadius: '3px',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: isDark ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)',
                  },
                }}
              >
                <Stack direction="column" spacing={0} w="100%">
                  {links}
                </Stack>
              </Box>

              <Box
                ref={bottomSectionRef}
                position="absolute"
                bottom="0"
                left="0"
                right="0"
                px="16px"
                pb="14px"
              >
                {brokerConnected && brokerAccounts.length > 0 && (
                  <Box mb="12px">
                    <Text fontSize="xs" fontWeight="medium" color={useColorModeValue("gray.500", "gray.400")} mb="6px" fontFamily="'IBM Plex Sans', sans-serif">
                      Trade account
                    </Text>
                    <Button
                      size="sm"
                      w="100%"
                      justifyContent="space-between"
                      rightIcon={<Icon as={MdAccountBalance} w={3.5} h={3.5} color="#A0AEC0" />}
                      borderRadius="6px"
                      border="1px solid"
                      borderColor={useColorModeValue("gray.200", "gray.600")}
                      bg={useColorModeValue("white", "#151517")}
                      color="#A0AEC0"
                      fontSize="xs"
                      fontFamily="'IBM Plex Sans', sans-serif"
                      fontWeight="medium"
                      textTransform="uppercase"
                      isDisabled={accountsLoading || isSwitchingAccount}
                      onClick={onAccountModalOpen}
                      _hover={{ bg: useColorModeValue("gray.100", "gray.700") }}
                      overflow="hidden"
                    >
                      <Text as="span" noOfLines={1} overflow="hidden" textOverflow="ellipsis" minW={0} flex={1} display="block">
                        {(() => {
                          if (accountsLoading) return "Loading...";
                          const current = brokerAccounts.find(
                            (a: { accountCode: string; brokerName: string }) =>
                              a.accountCode === activeAccountCode && a.brokerName === activeBrokerName
                          );
                          if (!current) return activeAccountCode ?? "Select account";
                          const fromCustom = current.customName?.trim();
                          if (fromCustom) return fromCustom;
                          if ("tradeLabel" in current && (current as { tradeLabel?: string }).tradeLabel) {
                            return (current as { tradeLabel: string }).tradeLabel;
                          }
                          return formatAccountDisplayLabelShort(current);
                        })()}
                      </Text>
                    </Button>
                    {isSwitchingAccount && (
                      <Flex align="center" gap="6px" mt="6px">
                        <Spinner size="xs" />
                        <Text fontSize="xs" color={useColorModeValue("gray.500", "gray.400")}>Switching...</Text>
                      </Flex>
                    )}
                  </Box>
                )}
                {brokerConnected && brokerAccounts.length === 0 && !accountsLoading && (
                  <Link as={NavLink} to="/profile" fontSize="xs" color={useColorModeValue("cyan.600", "cyan.400")} mb="12px" display="block">
                    Connect broker
                  </Link>
                )}
                {!brokerConnected && !accountsLoading && (
                  <Link as={NavLink} to="/profile" fontSize="xs" color={useColorModeValue("cyan.600", "cyan.400")} mb="12px" display="block">
                    Connect broker
                  </Link>
                )}
                {showSidebarResyncTrades ? (
                <GradientButton
                  w="100%"
                  showArrow={false}
                  fontSize="xs"
                  px="20px"
                  py="10px"
                  h="40px"
                  borderRadius="6px"
                  onClick={handleSidebarResyncTrades}
                  isLoading={isResyncing}
                  loadingText="Re-syncing..."
                  mb="12px"
                >
                  Re-sync Trade Account
                </GradientButton>
                ) : null}

                {/* NavSecondary: Notifications */}
                <VStack spacing="2px" mb="12px" align="stretch">
                  <Box position="relative">
                    <Box
                      ref={notificationsButtonRef as any}
                      as="button"
                      w="100%"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      px="20px"
                      py="10px"
                      h="40px"
                      borderRadius="6px"
                      border="1px solid"
                      borderColor={useColorModeValue("gray.300", "gray.600")}
                      bg="transparent"
                      color="#9CA3AF"
                      fontSize="xs"
                      fontFamily="'IBM Plex Sans', sans-serif"
                      fontWeight="medium"
                      textTransform="uppercase"
                      cursor="pointer"
                      transition="all 0.2s"
                      _hover={{ 
                        borderColor: useColorModeValue("gray.400", "gray.500"),
                        opacity: 0.9
                      }}
                      _active={{ 
                        opacity: 0.8,
                        transform: "scale(0.98)"
                      }}
                      onClick={isNotificationsMenuOpen ? onNotificationsMenuClose : onNotificationsMenuOpen}
                    >
                      <Icon as={AiOutlineBell} w="16px" h="16px" mr="8px" flexShrink={0} />
                      <Text color="#9CA3AF" fontSize="xs" fontFamily="'IBM Plex Sans', sans-serif" fontWeight="medium" textTransform="uppercase">Notifications</Text>
                    </Box>
                    
                    {isNotificationsMenuOpen && (
                      <Portal>
                        <Box
                          ref={notificationsMenuListRef}
                          position="fixed"
                          minW="280px"
                          maxW="320px"
                          maxH="400px"
                          bg={cardBg}
                          border="1px solid"
                          borderColor={cardBorder}
                          borderRadius="8px"
                          boxShadow="lg"
                          p={0}
                          zIndex={1500}
                          overflowY="auto"
                        >
                          {/* Notifications Header */}
                          <Box p="12px" borderBottom="1px solid" borderColor={cardBorder}>
                            <Text
                              fontSize="sm"
                              fontWeight="semibold"
                              color="#9CA3AF"
                              fontFamily="'Urbanist', sans-serif"
                            >
                              Notifications
                            </Text>
                            <Box
                              as="button"
                              type="button"
                              fontSize="xs"
                              fontFamily="'Urbanist', sans-serif"
                              color={cardTextSecondary}
                              bg="transparent"
                              mt="6px"
                              _hover={{ color: cardText }}
                              onClick={() => {
                                setNotificationModalFocusId(null);
                                onNotificationsMenuClose();
                                onNotificationsModalOpen();
                              }}
                            >
                              View all notifications
                            </Box>
                          </Box>
                          
                          {/* Notifications List */}
                          <Box>
                            {notificationsPreview.length === 0 ? (
                              <Box p="24px" textAlign="center">
                                <Text
                                  fontSize="sm"
                                  color="#9CA3AF"
                                  fontFamily="'Urbanist', sans-serif"
                                >
                                  No notifications
                                </Text>
                              </Box>
                            ) : (
                              <>
                                {notificationsPreview.map((n) => (
                                  <Box
                                    key={n.id}
                                    as="button"
                                    type="button"
                                    w="100%"
                                    textAlign="left"
                                    px="16px"
                                    py="12px"
                                    borderBottom="1px solid"
                                    borderColor={cardBorder}
                                    cursor="pointer"
                                    bg="transparent"
                                    _hover={{ bg: notificationRowHoverBg }}
                                    onClick={() => {
                                      setNotificationModalFocusId(n.id);
                                      onNotificationsMenuClose();
                                      onNotificationsModalOpen();
                                    }}
                                  >
                                    <Flex direction="column" align="flex-start" gap={1}>
                                      <Flex align="center" justify="space-between" w="100%">
                                        <Text
                                          fontSize="sm"
                                          fontWeight={n.isRead ? "normal" : "semibold"}
                                          color={n.isRead ? "#9CA3AF" : cardText}
                                          fontFamily="'Urbanist', sans-serif"
                                          noOfLines={1}
                                        >
                                          {n.title}
                                        </Text>
                                        {!n.isRead && (
                                          <Box w="8px" h="8px" borderRadius="full" bg={cardText} flexShrink={0} />
                                        )}
                                      </Flex>
                                      <Text
                                        fontSize="xs"
                                        color={cardTextSecondary}
                                        fontFamily="'Urbanist', sans-serif"
                                        noOfLines={2}
                                      >
                                        {n.message}
                                      </Text>
                                      <Text
                                        fontSize="xs"
                                        color={cardTextSecondary}
                                        fontFamily="'Urbanist', sans-serif"
                                      >
                                        {n.time}
                                      </Text>
                                    </Flex>
                                  </Box>
                                ))}
                              </>
                            )}
                          </Box>
                        </Box>
                      </Portal>
                    )}
                  </Box>
                </VStack>

                <NotificationModal
                  isOpen={isNotificationsModalOpen}
                  onClose={() => {
                    setNotificationModalFocusId(null);
                    onNotificationsModalClose();
                    void loadNotificationsPreview();
                  }}
                  initialFocusNotificationId={notificationModalFocusId}
                  onUnreadCountChange={(c) => {
                    if (typeof c === "number") setUnreadCount(Math.max(0, c));
                  }}
                />

                {/* NavUser: Profile section */}
                <Box position="relative">
                  <Box
                    w="100%"
                    h="auto"
                    p="8px"
                    borderRadius="6px"
                    cursor="pointer"
                    transition="background 0.2s"
                    bg={isProfileMenuOpen ? cardActiveBg : "transparent"}
                    _hover={{ bg: cardHoverBg }}
                    _active={{ bg: cardActiveBg }}
                    ref={profileCardRef}
                    onClick={isProfileMenuOpen ? onProfileMenuClose : onProfileMenuOpen}
                  >
                    <Flex alignItems="center" w="100%" justifyContent="space-between">
                      <Flex alignItems="center" flex="1" minW="0">
                        <Avatar
                          src={avatarImage}
                          name={fullName}
                          size="sm"
                          w="32px"
                          h="32px"
                          mr="12px"
                          flexShrink={0}
                          borderRadius="6px"
                        />
                        <Box flex="1" textAlign="left" minW="0">
                          <Text
                            fontSize="sm"
                            fontWeight="medium"
                            color={cardText}
                            fontFamily="'Urbanist', sans-serif"
                            isTruncated
                          >
                            {fullName}
                          </Text>
                          <Text
                            fontSize="xs"
                            color={cardTextSecondary}
                            fontFamily="'Urbanist', sans-serif"
                            isTruncated
                          >
                            {email}
                          </Text>
                        </Box>
                      </Flex>
                      <Icon
                        as={AiOutlineMore}
                        w="16px"
                        h="16px"
                        color={cardTextSecondary}
                        flexShrink={0}
                        ml="8px"
                      />
                    </Flex>
                  </Box>
                  
                  {isProfileMenuOpen && (
                    <Portal>
                      <Box
                        ref={menuListRef}
                        position="fixed"
                        minW={cardWidth || "200px"}
                        maxW="calc(100vw - 32px)"
                        bg={cardBg}
                        border="1px solid"
                        borderColor={cardBorder}
                        borderRadius="8px"
                        boxShadow="lg"
                        p={0}
                        zIndex={1500}
                      >
                        <svg width="0" height="0" style={{ position: 'absolute' }}>
                          <defs>
                            <linearGradient id="mobileIconGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                              <stop offset="0%" stopColor="#38BBD1" />
                              <stop offset="100%" stopColor="#3EEAEC" />
                            </linearGradient>
                            <linearGradient id="mobileLogoutIconGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                              <stop offset="0%" stopColor="#E00101" />
                              <stop offset="100%" stopColor="#FE4244" />
                            </linearGradient>
                          </defs>
                        </svg>
                        {/* User Profile Section at Top */}
                        <Box p="12px" borderBottom="1px solid" borderColor={cardBorder}>
                          <Flex alignItems="center">
                            <Avatar
                              src={avatarImage}
                              name={fullName}
                              size="sm"
                              w="32px"
                              h="32px"
                              mr="12px"
                              flexShrink={0}
                              borderRadius="8px"
                            />
                            <Box flex="1" minW="0">
                              <Text
                                fontSize="sm"
                                fontWeight="medium"
                                color="#9CA3AF"
                                fontFamily="'Urbanist', sans-serif"
                                isTruncated
                              >
                                {fullName}
                              </Text>
                              <Text
                                fontSize="xs"
                                color="#9CA3AF"
                                fontFamily="'Urbanist', sans-serif"
                                isTruncated
                              >
                                {email}
                              </Text>
                            </Box>
                          </Flex>
                        </Box>
                        
                        <Box>
                          <Box
                            as="button"
                            w="100%"
                            display="flex"
                            alignItems="center"
                            px="12px"
                            py="8px"
                            onClick={() => {
                              handleProfileClick();
                              onProfileMenuClose();
                            }}
                            bg="transparent"
                            _hover={{ bg: cardHoverBg }}
                            fontFamily="'Urbanist', sans-serif"
                            fontSize="sm"
                            color="#9CA3AF"
                          >
                            <Box
                              display="inline-flex"
                              alignItems="center"
                              justifyContent="center"
                              w="16px"
                              h="16px"
                              mr="12px"
                              sx={{
                                '& svg': {
                                  fill: 'url(#mobileIconGradient)',
                                  width: '16px',
                                  height: '16px',
                                }
                              }}
                            >
                              <Icon as={AiOutlineUser} w="16px" h="16px" />
                            </Box>
                            Account
                          </Box>
                          <Box
                            w="100%"
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            px="12px"
                            py="8px"
                            bg="transparent"
                            _hover={{ bg: cardHoverBg }}
                          >
                            <Text
                              fontFamily="'Urbanist', sans-serif"
                              fontSize="sm"
                              color="#9CA3AF"
                            >
                              Light/Dark Mode
                            </Text>
                            <Switch
                              isChecked={isDark}
                              onChange={() => setTheme(isDark ? "light" : "dark")}
                              size="md"
                              sx={{
                                '& .chakra-switch__track[data-checked]': {
                                  bg: 'linear-gradient(135deg, #38BBD1, #3EEAEC) !important',
                                }
                              }}
                            />
                          </Box>
                          <Box
                            h="1px"
                            bg={cardBorder}
                            mx="12px"
                            my="4px"
                          />
                          <Box
                            as="button"
                            w="100%"
                            display="flex"
                            alignItems="center"
                            px="12px"
                            py="8px"
                            onClick={() => {
                              if (!isSigningOut) {
                                handleSignOut();
                                onProfileMenuClose();
                              }
                            }}
                            disabled={isSigningOut}
                            bg="transparent"
                            _hover={{ bg: cardHoverBg }}
                            fontFamily="'Urbanist', sans-serif"
                            fontSize="sm"
                            cursor={isSigningOut ? "not-allowed" : "pointer"}
                            opacity={isSigningOut ? 0.5 : 1}
                          >
                            <Box
                              display="inline-flex"
                              alignItems="center"
                              justifyContent="center"
                              w="16px"
                              h="16px"
                              mr="12px"
                              sx={{
                                '& svg': {
                                  fill: 'url(#mobileLogoutIconGradient)',
                                  width: '16px',
                                  height: '16px',
                                }
                              }}
                            >
                              <Icon as={AiOutlineLogout} w="16px" h="16px" />
                            </Box>
                            <Box
                              bgGradient="linear-gradient(135deg, #E00101, #FE4244)"
                              bgClip="text"
                              color="transparent"
                            >
                              {isSigningOut ? "Signing out..." : "Log out"}
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Portal>
                  )}
                </Box>
              </Box>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
        <AccountSelectorModal
          isOpen={isAccountModalOpen}
          onClose={onAccountModalClose}
          accounts={brokerAccounts}
          activeAccountCode={activeAccountCode}
          activeBrokerName={activeBrokerName}
          onSelectAccount={handleSwitchAccount}
          onRefetchAccounts={refetchBrokerAccounts}
          onAccountRemoved={removeTradeAccount}
          loading={accountsLoading}
          isSwitching={isSwitchingAccount}
          isConnected={brokerConnected}
        />
      </Flex>
    );
  }

  export default SidebarResponsive
